import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
const propTypes = {
  /**
   * Flag to accessibly hide the input label
   */
  hideLabel: PropTypes.bool,
  /**
   * DOM ID for the input element
   */
  inputId: PropTypes.string.isRequired,
  /**
   * Flag to indicate whether this input is a required field.
   */
  isRequired: PropTypes.bool,
  /**
   * Text label shown above the input element
   */
  label: PropTypes.string.isRequired,
  /**
   * Appended to the text label.
   * Defaults to "(optional)" for non-required inputs,
   * but can be overridden if needed.
   */
  optionalInputLabel: PropTypes.string,
  /**
   * Append asterisk to label
   */
  showRequiredAsterisk: PropTypes.bool
};
function FormInputLabel(_ref) {
  let {
    hideLabel,
    inputId,
    isRequired,
    label,
    optionalInputLabel = '(optional)',
    showRequiredAsterisk
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    className: classnames('asc-form-label', {
      'visually-hide': hideLabel
    }),
    htmlFor: inputId
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames({
      'is-required': isRequired
    })
  }, label), showRequiredAsterisk && isRequired && /*#__PURE__*/React.createElement("span", {
    className: "asc-form-required-asterisk"
  }, "\xA0*"), !isRequired && optionalInputLabel && /*#__PURE__*/React.createElement("span", null, "\xA0", optionalInputLabel)));
}
FormInputLabel.propTypes = propTypes;
export default FormInputLabel;